module.exports = __webpack_public_path__ + "static/media/NFC.562018ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/mobile/NFC.svg
// module id = 103
// module chunks = 0